import { userProfile } from './user-profile';

export const en = {
  userProfile,
};
